import Request from '@/api/request'

class PublicationsApi extends Request {
  unlock(password) {
    // Без повторов: каждый повтор с неверным паролем списал бы попытку из лимита подбора
    return this.request('post', 'api/publications/' + this.publicationId + '/access', { password }, {
      retry: { retries: 0 },
    })
  }

  getBootstrap() {
    return this.request(
      'get',
      'api/publications/' + this.publicationId + '/bootstrap'
    )
  }

  getGroups() {
    return this.request('get', 'api/publications/' + this.publicationId + '/groups')
  }

  getTeachers() {
    return this.request(
      'get',
      'api/publications/' + this.publicationId + '/teachers'
    )
  }

  getCabinets() {
    return this.request(
      'get',
      'api/publications/' + this.publicationId + '/cabinets'
    )
  }

  getGroupLessons(data) {
    return this.request('post', 'api/publications/group/lessons', { ...data, publicationId: this.publicationId }, {
      cancel: 'getGroupLessons',
    })
  }

  getTeacherLessons(data) {
    return this.request('post', 'api/publications/teacher/lessons', { ...data, publicationId: this.publicationId }, {
      cancel: 'getTeacherLessons',
    })
  }

  getCabinetLessons(data) {
    return this.request('post', 'api/publications/cabinet/lessons', { ...data, publicationId: this.publicationId }, {
      cancel: 'getCabinetLessons',
    })
  }
}

export default new PublicationsApi()
